// extracted by mini-css-extract-plugin
export default {"filter-scroll":"table-filter-root_filter-scroll__d8NFs","filter-table-container":"table-filter-root_filter-table-container__cbYXM"};